<template>
  <div>
    <EquipmentEditHeader v-if="isAdmin" />
    <EquipmentTable @select="$emit('select', $event.data as Seals)" />
  </div>
</template>

<script setup lang="ts">
import { provide } from "vue";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import EquipmentTable from "@/components/equipment/EquipmentTable.vue";
import { useThrustChambersSeals } from "@/composables/equipment/sealThrustChambers/thrustChambers";
import type { Seals } from "gql/api";

const props = defineProps<{
  isAdmin: boolean;
}>();

defineEmits<{
  (event: "select", data: Seals): void;
}>();

const sealsearch = useThrustChambersSeals(props.isAdmin);

provide("equipment", sealsearch);
</script>
